import { useState, useContext } from "react";
import FormContainer from "components/form-container";
import ProgressBar from "components/progress-bar";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import { Input } from "components/input";
import { getQueryParams } from "lib/utils";
import AuthContext from "contexts/AuthContext";
import { isValidEmail } from "lib/utils";
import { useTranslation } from "react-i18next";
import InputValidation from "components/input-validation";
import ForgotPasswordLink from "components/forgot-password-link";
import PasswordInput from "components/password-input";
import LoadingSpinner from "components/loading-spinner";

export default function InStoreSigninExists() {
  const { t } = useTranslation();
  const [emailAlarm, setEmailAlarm] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = getQueryParams(location.search);
  const [username, setUsername] = useState(
    () => localStorage.getItem("quickRegEmailInput") || ""
  );
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { loginHandler, loginError } = useContext(AuthContext);

  const targetPath = t("urls.signup_store_checklist");

  const submitHandler = () => {
    setIsLoading(t("ui.signing_in"));
    loginHandler(
      { username, password },
      {
        onSuccess: () => {
          const navigateOptions = {
            //if only sign-in without case, navigate home. Otherwise continue with case
            pathname: targetPath,
          };
          if (queryParams) {
            navigateOptions.search = createSearchParams(queryParams).toString();
          }
          navigate(navigateOptions);
          navigate(0);
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        },
      },
      {
        onError: () => {
          setIsLoading(false);
        },
      }
    );
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 88px)",
        }}
      >
        <LoadingSpinner isLoading={isLoading} />
      </div>
    );
  }

  return (
    <FormContainer
      submitLabel={t("ui.button_continue")}
      onSubmit={submitHandler}
      submitParams={queryParams}
      secondaryLabel={t("ui.button_back")}
      secondaryHref={t("urls.signup_store_email")}
      secondaryParams={queryParams}
      submitDisabled={!username || !password || emailAlarm}
      className="min-h-[calc(100vh-71px)]"
    >
      <ProgressBar step={2} stepsNum={3} />
      <h2 className="font-semibold text-6xl max-w-lg">
        {t("ui.welcome_back")}
      </h2>

      <div className="w-full flex flex-col gap-x-large">
        <div>
          <Input
            label={t("ui.input_email")}
            type="email"
            id="username"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setEmailAlarm(!isValidEmail(e.target.value));
            }}
          />
        </div>
        <div>
          <PasswordInput
            label={t("ui.input_password")}
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="text-blue mt-regular text-sm cursor-pointer">
            <ForgotPasswordLink
              returnToPath={t("urls.signup_store_sign_in_exists")}
            />
          </div>
          <InputValidation errorMessage={loginError?.message} />
        </div>
      </div>
    </FormContainer>
  );
}
